<template>
    <v-dialog v-model="dialog" @click:outside="onClickOutside" :persistent="loading" no-click-animation max-width="500">
        <v-card flat :class="[{'pb-3': loading}]">
            <v-card-title>
                <div class="app-title">
                    {{ $t('common.profilePhoto') }}
                </div>
            </v-card-title>
            <v-divider/>
            <loading-spinner class="ma-0" height="50px" v-if="loading"/>
            <v-row v-else no-gutters>
                <v-col :cols="5.5">
                    <v-btn x-large depressed @click="takePicture" block color="transparent">
                        <v-icon left>mdi-camera-outline</v-icon>
                        {{ $t('common.camera') }}
                    </v-btn>
                </v-col>
                <v-col cols="1" class="text-center">
                    <v-divider vertical/>
                </v-col>
                <v-col :cols="5.5">
                    <input
                        type="file"
                        ref="fileUpload"
                        style="display: none"
                        @change="onFileSelected"
                        accept="image/png, image/jpeg"
                    >
                    <v-btn x-large depressed @click="$refs.fileUpload.click()" block color="transparent">
                        <v-icon left>mdi-image-search-outline</v-icon>
                        {{ $t('common.gallery') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>

import {db, storageRef} from '@/utils/Firebase'
import {mapMutations, mapState} from 'vuex'

import firebase from 'firebase/app'
import "firebase/auth";

import {CameraResultType, Plugins} from '@capacitor/core';
import LoadingSpinner from "@/components/common/LoadingSpinner";

const {Camera} = Plugins;

export default {
    components: {LoadingSpinner},
    data() {
        return {
            dialog: false,
            selectedFile: null,
            loading: false,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
    },
    methods: {
        ...mapMutations(['setDialogActive', 'setCurrentUser']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.state = 'waitingPhoto'
        },
        onClickOutside() {
            const vm = this
            if (!vm.loading) vm.hide()
        },
        async takePicture() {
            const vm = this
            const image = await Camera.getPhoto({
                quality: 80,
                allowEditing: false,
                resultType: CameraResultType.Uri,
                width: 1200,
                source: "CAMERA"
            });

            vm.selectedFile = await fetch(image.webPath).then(r => r.blob())
            await vm.uploadTask()
        },
        async onFileSelected() {
            const vm = this
            vm.selectedFile = vm.$refs.fileUpload.files[0]
            await vm.uploadTask()
        },
        async uploadTask() {
            const vm = this
            vm.loading = true
            let savePath = `/${vm.currentUser.uid}/avatar.jpg`
            let uploadTask = await storageRef.child(savePath).put(vm.selectedFile)
            let downloadURL = await uploadTask.ref.getDownloadURL()
            await db.collection('users').doc(vm.currentUser.uid).update({avatar: downloadURL})
            let user = firebase.auth().currentUser
            await user.updateProfile({photoURL: downloadURL})
            await vm.setCurrentUser(user)
            vm.loading = false
            vm.hide()
            vm.toast(vm.$t('common.profilePhoto_updated'))
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>

.app-title {
    font-size: 17px;
    line-height: 22px;
    font-weight: 700;
    margin: auto;
}

</style>
